"use client";

import {
	StatsigProvider as StatsigProviderBase,
	useClientAsyncInit,
} from "@statsig/react-bindings";
import { StatsigSessionReplayPlugin } from "@statsig/session-replay";
import { StatsigAutoCapturePlugin } from "@statsig/web-analytics";
import type { ReactNode } from "react";

export function StatsigProvider({ children }: { children: ReactNode }) {
	const { client } = useClientAsyncInit(
		process.env.NEXT_PUBLIC_STATSIG_CLIENT_KEY!,
		{
			// userID
		},
		{
			plugins: [
				new StatsigAutoCapturePlugin(),
				new StatsigSessionReplayPlugin(),
			],
		},
	);

	return <StatsigProviderBase client={client}>{children}</StatsigProviderBase>;
}
